export const DEFAULT_AIRTIME_NETWORKS = ["MTN-NG", "Glo", "9Mobile", "Airtel"];

export const DEFAULT_DATA_NETWORKS = ["MTN-NG", "Glo", "9Mobile", "Airtel"];

export const DEFAULT_DATA_BUNDLES = [
  "Do_More 75GB",
  "Better_Browse 100GB",
  "Ying 150GB",
];

export const DEFAULT_INTERNET_PROVIDERS = [
  "Spectranet",
  "Smile",
  "Tizeti",
  "IPNX",
];

export const DEFAULT_INTERNET_PACKAGES = [
  "Do_More 75GB",
  "Better_Browse 100GB",
  "Ying 150GB",
];

export const DEFAULT_TV_PROVIDERS = ["DSTV", "GOTV", "Startimes"];

export const DEFAULT_TV_PACKAGES = [
  "Family",
  "Compact",
  "Compact Plus",
  "Premium",
];

export const DEFAULT_CREDIT_PROVIDERS = ["Bet9ja"];

export const DEFAULT_ELECTRICITY_PROVIDERS = ["Eko Electric", "Ikeja Electric"];

export const DEFAULT_METER_TYPES = ["Prepaid", "Postpaid"];
